import { createStore } from './create-store';

/**
 * @template T
 * @param {T | () => T} stateOrStateFn
 * @returns {() => ReturnType<import('./create-store').CreateStore<T>>}
 */
const globalStore = (stateOrStateFn) => {
    let store;
    let storeInitialized = false;

    const getStore = () => {
        if (!store) {
            throw new Error('Store not initialized yet');
        }

        return store;
    };

    getStore.init = () => {
        if (storeInitialized) {
            console.warn("initStore() - Can't initialize store more then once");
        }
        storeInitialized = true;

        delete getStore.init;

        store = createStore(
            {
                state: typeof stateOrStateFn === 'function' ? stateOrStateFn() : stateOrStateFn,
            },
            { prefix: 'global' },
        );
    };

    return getStore;
};

export default globalStore;
